type Entries<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][]

function entries<T extends Object>(obj: T) {
  return Object.entries(obj) as Entries<T>
}

function keys<T extends Object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>
}

export const ObjectUtils = {
  entries,
  keys,
}
